import React from 'react';
import Button from 'components/Button';
import { SearchHubCardProps, StatusEnums } from './SearchHubCard.props';

const SearchHubCard = React.memo<SearchHubCardProps>(({ order, showModalWithNum }) => {
    return (
        <div className="p-3 rounded border mb-3" data-testid='SearchHubCard'>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="font-weight-bold">
                    {order?.customer_name || order?.order_number}
                </span>
                <span className="font-weight-light">
                    {order?.customer_name ? "نام مشتری" : "شماره سفارش"}
                </span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <span className="font-weight-bold">
                    {order?.vendor_name || order?.shelf_number}
                </span>
                <span className="font-weight-light">
                    {order?.vendor_name ? "وندور" : "شماره قفسه"}
                </span>
            </div>
            <Button
                type="submit"
                data-testid='Button'
                btnText={+order?.status !== StatusEnums.delivered ? "تحویل دادم" : "تحویل داده شده"}
                className="solid w-100 h-75 is-pink m-0"
                handleClick={() =>
                    showModalWithNum({
                        show: true,
                        order_number: order?.order_number,
                    })
                }
                disabled={+order?.status === StatusEnums.delivered}
            />
        </div>
    );
});

export default SearchHubCard;
